// @ts-strict-ignore
import {useCurrentProject} from 'common/contexts/react/current-project-context';
import {FeatureRolloutName, FeatureRollouts} from 'common/report/util/feature-sampling';

/**
 * A hook that checks if a feature rollout is enabled for the current project.
 *
 * @param flag - The feature rollout to check.
 */
export function useFeatureRollout(rollout: FeatureRolloutName) {
  const currentProject = useCurrentProject();

  return FeatureRollouts[rollout].isEnabled(currentProject.get().value);
}
